import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

import { POBrowser } from 'js-pageoffice'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10 * 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (config.method === 'get') {
      config.data = true
      config.headers['Content-type'] = 'application/x-www-form-urlencoded'
    }

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
      config.headers['Authorization'] = getToken()
      POBrowser.setProxyBaseAPI('/api')
      // 必须。向PageOffice后端请求设置header，支持多次调用setHeader()设置更多的值，具体属性名称和属性值以您实际开发为准。
      POBrowser.setHeader('Authorization', 'Bearer ' + getToken())
    }

    // 系统标识符，主要用于过滤权限使用，有此标识，返回权限时，进显示该系统权限符--需要后端支持
    config.headers['SystemType'] = 'sso'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log(res, 'response.data')

    // 判断响应数据是否为Blob类型
    if (res instanceof Blob) {
      // blob 响应可能是真实文件，也可能是后端全局异常返回的 JSON 错误体（HTTP 200 + application/json）。
      // 若为 JSON 错误体，解析真实错误信息并 reject，避免被调用方当成 PDF/Excel 下载导致文件损坏。
      if (res.type && res.type.indexOf('json') > -1) {
        return res.text().then(text => {
          let msg = '下载失败'
          try {
            const data = JSON.parse(text)
            msg = data.msg || msg
          } catch (e) {
            // 非 JSON 文本，保持默认提示
          }
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
          return Promise.reject(new Error(msg))
        })
      }
      // 如果是Blob类型，直接返回完整响应，包含headers等信息供调用者处理
      return res
    }

    // 根据自定义状态码判断请求是否成功，这里以200作为成功的示例，你可以根据实际后端定义修改
    if (res.code && res.code !== '200') {
      // 显示错误提示
      Message({
        message: res.msg || '未知错误',
        type: 'error',
        duration: 5 * 1000
      })
      // 返回被拒绝的Promise，确保调用者的catch能捕获到错误
      return Promise.reject(new Error(res.msg || '未知错误'))
    }
    return res
  },
  error => {
    const response = error.response
    if (response) {
      const status = response.status
      const msgs = response.data?.msg || response.data?.message
      handleErrorResponseByStatus(status, msgs)
    } else {
      // 网络错误等情况
      Message({
        message: '网络连接异常，请检查网络设置',
        type: 'error',
        duration: 5 * 1000
      })
    }
    // 返回被拒绝的Promise
    return Promise.reject(error)
  }
)

// 提取出来的根据具体返回数据中的错误码处理错误的函数
function handleErrorResponse(res) {
  const code = res.code

  console.log()
  if (code === '401') {
    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    if (code === '401' || code === 50008 || code === 50012 || code === 50014) {
      // to re-login
      MessageBox.confirm('你的登录已失效，可重新登录或留在当前页', '未登录', {
        confirmButtonText: '重新登录',
        cancelButtonText: '留在页面',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    }
  } else {
    const res = response.data
    return res
    Message({
      message: 11111111111111 || '未知错误',
      type: 'error',
      duration: 5 * 1000
    })
  }
}

// 提取出来的根据HTTP状态码处理错误的函数
function handleErrorResponseByStatus(status, msgs) {
  let msg = ''
  switch (status) {
    case 403:
      msg = msgs || '无操作权限，请联系系统管理员'
      break
    case 404:
      msg = msgs || '请求资源不存在，请检查请求地址'
      break
    case 500:
      msg = msgs || '服务器错误，请联系系统管理员'
      break
    case 502:
      msg = msgs || '网关错误，请联系系统管理员'
      break
    case 503:
      msg = msgs || '服务不可用，请稍后再试'
      break
    case 504:
      msg = msgs || '网关超时，请联系系统管理员'
      break
    default:
      msg = msgs || '错误，请联系系统管理员'
  }
  Message({
    message: msg || '未知错误',
    type: 'error',
    duration: 5 * 1000
  })
}

export default service
